import ApiService from "@/core/services/api.service";
import Vue from "vue";
import { axios } from "vue/types/umd";
import { ActionTree } from "vuex";
import _ from "lodash";
import {
  Message,
  VesselProfileData,
  VesselProfileHatch,
  VesselProfileResponse,
} from "@/types/vesselProfileQC";


// action types
export const QC_FETCH_VESSEL_PROFILE = "QC_fetchVesselProfile";
export const QC_SET_SELECTED_HATCH_INDEX = "QC_setSelectedHatchIndex";

// mutation
export const QC_UPDATE_VESSEL_PROFILE = "QC_updateVesselProfile";
export const QC_SET_VESSEL_PROFILE_ = "QC_setVesselProfile";

export const QC_SET_VESSELPROFILELIST = "QC_setVesselList";
export const QC_SET_VESSEL_PROFILE_ERROR = "QC_setVesselError";

export const QC_MUTATE_SELECTED_HATCH_INDEX = "QC_mutateSelectedHatchId";




const reorderLabels = (vesselProfileHatches) => {
  let clonedVesselProfileHatches = _.cloneDeep(vesselProfileHatches);
  let start = 0;

  return clonedVesselProfileHatches.map(function(h, index) {
    if (h.hasBayFore) {
      if (!state.vesselProfileQC.manualBayNumbering) 
        h.bayFore = start + 1;
    } else {
      h.bayFore = 0;
    }

    if (h.hasBay40) {
      if (!state.vesselProfileQC.manualBayNumbering) 
        h.bay40 = start + 2;
    } else {
      h.bay40 = 0;
    }

    if (h.hasBayAfter) {
      if (!state.vesselProfileQC.manualBayNumbering) 
        h.bayAfter = start + 3;
    } else {
      h.bayAfter = 0;
    }

    if (!state.vesselProfileQC.manualBayNumbering)
      if (!h.hasBayAfter && !h.hasBay40 && h.hasBayFore) {
        start += 2;
      } else {
        start += 4;
      }
    return h;
  });
};

/* function isBaySelectionValid(selectedHatchDataQC) {
  if (
    selectedHatchDataQC.hasBay40 &&
    ((selectedHatchDataQC.hasBayFore && !selectedHatchDataQC.hasBayAfter) ||
      (!selectedHatchDataQC.hasBayFore && selectedHatchDataQC.hasBayAfter))
  ) {
    Vue.$toast.open({
      message:
        "Invalid bay selection: fix bay selection before selecting another hatch",
      type: "error",
      position: "top",
    });
    return false;
  }

  if (
    selectedHatchDataQC.hasBayAfter &&
    !selectedHatchDataQC.hasBay40 &&
    !selectedHatchDataQC.hasBayFore
  ) {
    Vue.$toast.open({
      message:
        "Invalid bay selection: fix bay selection before selecting another hatch",
      type: "error",
      position: "top",
    });
    return false;
  }
  return true;
} */


type State = {
  isLoading: boolean;
  vesselProfileQC: VesselProfileData;
  vesselProfileHatches: VesselProfileHatch[];
  selectedHatchIndex: number;
  selectedHatchDataQC: VesselProfileHatch;
  vesselProfileId: number;
  mirroredBays: {
    Fore: boolean;
    "40": boolean;
    After: boolean;
  };
  vesselProfileList: VesselProfileHatch[];
  message: Message[];
  errors: Error[];
  totalItems: number;
};

const initialVesselProfile: VesselProfileData = {
  vesselProfileId: 0,
  vesselProfileName: "Default Name",
  manualBayNumbering: false,
  vesselProfileHatches: [
    {
      id: 0,
      vesselHatchType: 1,
      sequence: 1,
      minHoldTiers: 4,
      maxHoldTiers: 4,
      holdRows: 4,
      minDeckTiers: 12,
      maxDeckTiers: 88,
      deckRows: 10,
      hasBayFore: false,
      hasBayAfter: false,
      hasBay40: false,
      bayFore: 1,
      bayAfter: 2,
      bay40: 3,
      onDeckFore: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
      onDeckAfter: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
      onDeck40: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
      holdFore: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
      holdAfter: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
      hold40: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      },
    },
  ],
  load:{
    completed: 0,
     planned: 0,
     qcUnassigned: 0,
     remained: 0,
     total: 0,
     deck: [],
     hold: []
 },
  discharge:{
    completed: 0,
     planned: 0,
     qcUnassigned: 0,
     remained: 0,
     total: 0,
     deck: [],
     hold: []
 }
};

const state: State = {
  isLoading: false,
  vesselProfileQC: initialVesselProfile,
  selectedHatchDataQC: initialVesselProfile.vesselProfileHatches[0],
  vesselProfileHatches: initialVesselProfile.vesselProfileHatches,
  selectedHatchIndex: 0,
  vesselProfileId: 0,
  errors: [],
  mirroredBays: {
    Fore: false,
    "40": false,
    After: false,
  },
  totalItems: 0,
  vesselProfileList: [],
  message: [],
};


const getters = {
  getIsLoadingQC: (state) => state.isLoading,
  getSelectedQCHatchData(state: State) {
    return state.selectedHatchDataQC;
  },
  getQCVesselProfileHatches(state: State) {
    return state.vesselProfileQC.vesselProfileHatches;
  },
  getQCVesselProfileLoads(state: State) {
    return state.vesselProfileQC.load;
  },
  getQCVesselProfileDischarge(state: State) {
    return state.vesselProfileQC.discharge;
  },
  getQCVesselProfileList(state: State) {
    return state.totalItems;
  },
  getQCVesselProfile(state: State) {
    return state.vesselProfileQC;
  },
  getQCSelectedVesselProfile(state: State) {
    return state.selectedHatchIndex;
  },
  getQCSelectedHatchIndex(state: State) {
    return state.selectedHatchIndex;
  },
};


const actions: ActionTree<any, any> = {
  setIsLoading(context, payload) {
    context.commit("QC_mutateIsLoading", payload);
  },

  [QC_FETCH_VESSEL_PROFILE]: async (
    context,
    payload
  ): Promise<VesselProfileResponse> => {
    return new Promise((resolve, body) => {
      ApiService.setHeader();
      context.commit("QC_mutateIsLoading", true);
      ApiService.post("/system/qcworkingplan/getprofileandcontainerslist", {
        voyageId: payload,
      })
        .then(({ data }) => {
          if (data.isSuccessful) {
            context.commit(QC_SET_VESSEL_PROFILE_, data);
          }

          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(QC_SET_VESSEL_PROFILE_ERROR, response.data.errors);
        })
        .finally(() => {
          context.commit("QC_mutateIsLoading", false);
        });
    });
  },
};


const mutations = {
  QC_mutateIsLoading(state: State, payload) {
    state.isLoading = payload;
  },

  [QC_SET_VESSEL_PROFILE_ERROR](state: State, error) {
    state.errors = error;
  },

  [QC_SET_VESSEL_PROFILE_](state, apiResult: VesselProfileResponse) {
    state.apiResult = apiResult;
    if (apiResult.isSuccessful) {
      console.log(apiResult.data)
      state.vesselProfileQC = apiResult.data;
      state.errors = [];
    } else {
      state.totalItems = 0;
      state.errors = apiResult.message;
    }
  },

  [QC_SET_VESSELPROFILELIST](state, apiResult) {
    state.apiResult = apiResult;
    if (apiResult.isSuccessful) {
      state.items = apiResult.data.items;
      state.totalItems = apiResult.data.totalItems;
      state.currentPage = apiResult.data.currentPage;
      state.errors = [];
    } else {
      state.totalItems = 0;
      state.errors = apiResult.message;
    }
  },

  [QC_UPDATE_VESSEL_PROFILE](state) {
    state.vesselProfile.vesselProfileHatches[state.selectedHatchIndex] = {
      ...state.selectedHatchDataQC,
    };
  }
};


export default {
  state,
  actions,
  mutations,
  getters,
};
